"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getConditionSchema = void 0;
const schemaComponents_1 = require("@/schemaComponents");
const ENABLE_SCRIPT_TYPE = false;
const getConditionSchema = ({ langId, }) => {
    return (0, schemaComponents_1.mergeSchema)({ schemaType: "object", properties: [] }, [
        {
            title: "テキストID",
            propertyName: "scriptId",
            schema: {
                schemaType: "text",
                required: true,
            },
        },
        ...(ENABLE_SCRIPT_TYPE
            ? [
                {
                    title: "タイプ",
                    propertyName: "scriptType",
                    schema: {
                        schemaType: "text",
                        required: true,
                    },
                },
            ]
            : []),
        {
            title: "テキスト",
            propertyName: "text",
            schema: {
                schemaType: "text",
            },
        },
        {
            title: "タグ",
            propertyName: "tags",
            schema: {
                schemaType: "selector",
                required: true,
                options: [
                    {
                        value: "skipped",
                        title: "スキップしたテキストのみを表示",
                    },
                ],
            },
        },
        ...(langId
            ? [
                {
                    title: "翻訳文", //  検索用
                    propertyName: `translations.${langId}`,
                    schema: {
                        schemaType: "text",
                    },
                },
                {
                    title: "Status",
                    propertyName: `translationStatus.${langId}`,
                    schema: {
                        schemaType: "selector",
                        options: [
                            {
                                value: null,
                                title: "未着手",
                            },
                            {
                                value: "translated",
                                title: "翻訳済み",
                            },
                            {
                                value: "corrected",
                                title: "校閲済み",
                            },
                        ],
                    },
                },
                {
                    title: "参照訳として利用",
                    tooltip: "このテキストが参照訳として使われないようにします",
                    propertyName: `translationIgnore.${langId}`,
                    schema: {
                        schemaType: "boolean",
                        invert: true,
                    },
                },
            ]
            : []),
    ]);
};
exports.getConditionSchema = getConditionSchema;
